//==============================================================================
// 画像入力フィールド
//==============================================================================
$(function() {
    $(document).on('change', '.image-container input[type="file"]', function(event) {
        const $container = $(this).closest('.image-container');
        const name = $container.attr('data-name');

        const file = event.target.files[0];
        // const maxSize = $container.attr('data-max');
        // if (maxSize) {
        //     const maxMB = maxSize * 1024 * 1024; // 2MB
        //     if(file && file.size > maxMB) {
        //         alert('画像サイズは' + maxSize + 'MBまでです。');
        //         return;
        //     }
        // }
        if (file) {
            const reader = new FileReader();
            reader.onload = function(e) {
                const base64Data = e.target.result;

                // Base64 data
                $container.find('[data-image-component="base64"]').val(base64Data);
                $container.find('[data-image-component="filename"]').val(file.name);
                $container.find('[data-image-component="updated"]').val('1');
                $container.find('[data-image-component="deleted"]').val(null);
                $container.find('[data-image-component="preview"]').attr('src', base64Data);
                $container.find('[data-image-component="editable"]').show();
                $container.find('[data-image-component="input"]').hide();
            };
            reader.readAsDataURL(file);
        }
    });
    $(document).on('click', '.image-container [data-image-component="change"]', function(event) {
        const $container = $(this).closest('.image-container');
        $container.find('input[type="file"]').trigger('click');
    });
    $(document).on('click', '.image-container [data-image-component="destroy"]', function(event) {
        const $container = $(this).closest('.image-container');
        const name = $container.attr('data-name');
        const id = $container.find('[data-image-component="id"]').val();
        if (id) {
            // 削除フラグを立てる
            $container.find('[data-image-component="updated"]').val(null);
            $container.find('[data-image-component="deleted"]').val('1');
        }
        $container.find('[data-image-component="base64"]').val(null);
        $container.find('[data-image-component="filename"]').val(null);
        $container.find('[data-image-component="updated"]').val(null);
        $container.find('[data-image-component="preview"]').attr('src', null);
        $container.find('input[type="file"]').val('');
        $container.find('[data-image-component="editable"]').hide();
        $container.find('[data-image-component="input"]').show();
    });
});
